import { useQuery } from '@apollo/client';
import { Context as AuthorizationContext } from 'authorization/Context';
import { OrganizationListQuery } from 'organization/Schema';
import { useContext, useState } from 'react';

const SKIPPED_ORG_TAX_IDS = ['994251978', '994236236'];

export function useLegalEntitiesQuery(state?: string) {
  const { organization: defaultOrganization } =
    useContext(AuthorizationContext);
  const [entities, setEntities] = useState<fhir.Organization[]>([]);

  const { loading, error } = useQuery(OrganizationListQuery, {
    skip: !defaultOrganization?.id,
    variables: { partOfId: defaultOrganization?.id, first: 1000, state },
    onCompleted: (entityData) => {
      setEntities(
        (entityData?.OrganizationList?.edges || [])
          .map((edge) => edge?.node)
          .filter(
            (item) =>
              !!item && !SKIPPED_ORG_TAX_IDS.includes((item as any)?.taxId)
          )
      );
    },
  });

  return {
    entities,
    error,
    loading,
  };
}
